import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "account-type-grid" };
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import AccountTypeLozenge from './AccountTypeLozenge.vue';
import MGButton from './MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AccountTypeGrid',
    props: {
        currentAccounts: {},
        creditAccounts: {},
        savingAccounts: {},
        insuranceInfo: {},
        mortgageInfo: {},
        creditInfo: {},
        investmentInfo: {},
        suggestedAssets: {},
        cols: {},
        showAddButton: { type: Boolean },
        filter: {},
        offline: { type: Boolean }
    },
    emits: ["account-type-click", "add-account-click", "alt-action"],
    setup(__props, { emit: __emit }) {
        _useCssVars(_ctx => ({
            "29807e03": ('repeat(' + (_ctx.cols ?? 2) + ', 1fr)')
        }));
        const props = __props;
        const emit = __emit;
        const router = useRouter();
        const allAccountTypes = ref([
            {
                label: 'Current Account',
                text: 'Connect with <b>OPEN BANKING</b>',
                textIcon: require('@/assets/figureofeight.png'),
                altAction: 'openAddCurrentAccountDrawer',
                icon: require('@/assets/accountTypes/current-account.png'),
                walkthrough: 'money-account-types',
                key: 'current-account'
            },
            {
                label: 'Credit Card',
                text: 'Connect with <b>OPEN BANKING</b>',
                textIcon: require('@/assets/figureofeight.png'),
                altAction: 'openAddCurrentAccountDrawer',
                icon: require('@/assets/accountTypes/credit-card.png'),
                walkthrough: 'money-account-types',
                key: 'credit-card'
            },
            {
                label: 'Savings',
                text: 'Connect with <b>OPEN BANKING</b>',
                textIcon: require('@/assets/figureofeight.png'),
                altAction: 'openAddCurrentAccountDrawer',
                icon: require('@/assets/accountTypes/savings-account.png'),
                walkthrough: 'money-account-types',
                key: 'savings-account'
            },
            {
                label: 'Investments',
                icon: require('@/assets/accountTypes/investments.png'),
                walkthrough: 'money-account-types',
                key: 'investments'
            },
            {
                label: 'Pension',
                icon: require('@/assets/accountTypes/pension.png'),
                walkthrough: 'money-account-types',
                key: 'pension'
            },
            {
                label: 'Mortgage',
                icon: require('@/assets/accountTypes/mortgage.png'),
                walkthrough: 'money-account-types',
                key: 'mortgage'
            },
            {
                label: 'Loans',
                icon: require('@/assets/accountTypes/loans.png'),
                walkthrough: 'money-account-types',
                key: 'loans'
            },
            {
                label: 'Insurance Policy',
                icon: require('@/assets/accountTypes/insurance.png'),
                walkthrough: 'money-account-types',
                key: 'insurance-policy'
            }
        ]);
        const accountTypes = computed(() => {
            let types = allAccountTypes.value;
            const longTermKeys = ['investments', 'pension', 'mortgage', 'loans'];
            const dayToDayKeys = ['current-account', 'credit-card', 'savings-account'];
            if (props.filter === 'lt') {
                types = types.filter(t => longTermKeys.includes(t.key));
            }
            else if (props.filter === 'd2d') {
                types = types.filter(t => dayToDayKeys.includes(t.key));
            }
            if (props.offline) {
                return types
                    .filter(t => t.key !== 'savings-account' && t.key !== 'credit-card')
                    .map(t => ({
                    ...t,
                    text: undefined,
                    textIcon: undefined
                }));
            }
            return types;
        });
        function suggestedCount(sectionPrefix) {
            if (!props.suggestedAssets)
                return 0;
            return props.suggestedAssets.filter(a => {
                const s = a.uiElement?.section || '';
                return s === sectionPrefix || s.startsWith(sectionPrefix + ' >');
            }).length;
        }
        function getAccountCount(accountTypeLabel) {
            switch (accountTypeLabel) {
                case 'Current Account':
                    return (props.currentAccounts?.length ?? 0) + suggestedCount('Day-to-day > Current');
                case 'Credit Card':
                    return (props.creditAccounts?.length ?? 0) + suggestedCount('Day-to-day > Credit');
                case 'Savings':
                    return (props.savingAccounts?.length ?? 0) + suggestedCount('Day-to-day > Savings');
                case 'Insurance Policy':
                    return (props.insuranceInfo?.length ?? 0) + suggestedCount('Insurance');
                case 'Mortgage':
                    return (props.mortgageInfo?.length ?? 0) + suggestedCount('Long-term > Mortgages');
                case 'Loans':
                    return (props.creditInfo?.length ?? 0) + suggestedCount('Long-term > Loans');
                case 'Pension':
                    return (props.investmentInfo?.filter(account => account.accountType?.name === 'Pension').length ?? 0) + suggestedCount('Long-term > Pensions');
                case 'Investments':
                    return (props.investmentInfo?.filter(account => account.accountType?.name === 'Investment').length ?? 0) + suggestedCount('Long-term > Investments');
                default:
                    return 0;
            }
        }
        function handleAddAccountClick() {
            emit('add-account-click');
        }
        function handleAccountTypeClick(accountType) {
            if (props.offline) {
                const routes = {
                    'current-account': '/Accounts/Current/Add',
                    'credit-card': '/Credit/Add',
                    'savings-account': '/Accounts/Savings/Add',
                    'investments': '/Investments/Add',
                    'pension': '/Pensions/Add',
                    'mortgage': '/Mortgages/Add',
                    'loans': '/Credit/Add',
                    'insurance-policy': '/Policies/Insurance/Add'
                };
                if (routes[accountType.key]) {
                    router.push(routes[accountType.key]);
                }
                return;
            }
            if (accountType.altAction && props.cols === 1) {
                emit('alt-action', accountType);
            }
            else {
                emit('account-type-click', accountType);
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accountTypes.value, (accountType) => {
                        return (_openBlock(), _createBlock(AccountTypeLozenge, {
                            key: accountType.key,
                            accountType: accountType.label,
                            iconUrl: accountType.icon,
                            accountCount: getAccountCount(accountType.label),
                            isAddButton: getAccountCount(accountType.label) === 0,
                            compactMode: _ctx.cols !== 1,
                            text: accountType.text,
                            textIcon: accountType.textIcon,
                            onClick: ($event) => (handleAccountTypeClick(accountType))
                        }, null, 8, ["accountType", "iconUrl", "accountCount", "isAddButton", "compactMode", "text", "textIcon", "onClick"]));
                    }), 128))
                ]),
                (_ctx.showAddButton)
                    ? (_openBlock(), _createBlock(MGButton, {
                        key: 0,
                        class: "add-account-button",
                        fullWidth: true,
                        noCaps: true,
                        text: `Add an account`,
                        plus: true,
                        onClick: handleAddAccountClick
                    }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
